'use client'
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  TransitionStartFunction,
  createContext,
  useEffect,
  useMemo,
  useState,
  useTransition,
} from 'react'

import { Loading } from '@/components'
import useDeviceGuid from '@/libs/hooks/use-device-guid'

export type TLoaderProps = { title?: string; description?: string }

export const LoaderContext = createContext<null | {
  startTransition: TransitionStartFunction
  pending: boolean
  loaderProps: TLoaderProps
  setLoaderProps: Dispatch<SetStateAction<TLoaderProps>>
}>(null)

const AppLoaderProvider = ({ children }: { children: ReactNode }) => {
  const { loading: loadingDeviceID } = useDeviceGuid()

  const [pending, startTransition] = useTransition()

  const [loaderProps, setLoaderProps] = useState<TLoaderProps>({
    title: undefined,
    description: undefined,
  })

  useEffect(() => {
    if (!pending) {
      setLoaderProps({})
    }
  }, [pending])

  const value = useMemo(
    () => ({
      startTransition,
      pending,
      loaderProps,
      setLoaderProps,
    }),
    [pending, startTransition, loaderProps],
  )

  return (
    <LoaderContext.Provider value={value}>
      {children}
      <Loading appear={pending || loadingDeviceID} {...loaderProps} />
    </LoaderContext.Provider>
  )
}

export default AppLoaderProvider
